import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-stam',
  template: `
    <p>
      stam works!
    </p>
  `,
  styles: [
  ]
})
export class StamComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
